export const ru = {
  controls: {
    shareLink: "Скопировать ссылку на конференцию",
    linkCopied: "Ссылка скопирована, поделитесь ею",
    shareModalTitle: "Ссылка на конференцию",
    shareModalDescription: "Скопируйте ссылку для входа в конференцию и отправьте её участникам",
    shareModalCopy: "Скопировать ссылку",
    shareModalShare: "Поделиться",
    fullscreenEnter: "Полноэкранный режим",
    fullscreenExit: "Выйти из полноэкранного режима",
    screenShare: "Показать экран",
    screenUnshare: "Прекратить показ",
    cameraOn: "Выключить камеру",
    cameraOff: "Включить камеру",
    micOn: "Выключить микрофон",
    micOff: "Включить микрофон",
    settings: "Настройки",
    exitConference: "Выйти из конференции",
    exitConfirm: "Покинуть конференцию?",
    exitYes: "Выйти",
    exitNo: "Отмена",
    cameraLocked: "Камера недоступна — нажмите для настройки",
    micLocked: "Микрофон недоступен — нажмите для настройки",
    selectMicrophone: "Выбрать микрофон",
    selectCamera: "Выбрать камеру",
    playbackOn: "Звук включён",
    playbackOff: "Звук выключен",
    startRecording: "Начать запись аудио",
    stopRecording: "Остановить запись",
    openSettings: "Открыть настройки",
    closeSettings: "Закрыть настройки",
    toolbar: "Управление конференцией"
  },
  m: {
    appName: "YourTeams",
    appTagline: "Видеоконференции без ограничений",
    createConference: "Создать конференцию",
    rejoinConference: "Вернуться в конференцию",
  },
  profile: {
    editName: "Изменить имя",
    welcome: "Добро пожаловать в YourTeams",
    enterNamePrompt: "Введите ваше имя",
    continue: "Продолжить",
    close: "Закрыть"
  },
  onboarding: {
    setupTitle: "Настройка камеры и микрофона",
    permissionTitle: "Разрешите доступ",
    permissionDescription: "Для участия в видеозвонках нужен доступ к вашей камере и микрофону",
    permissionHint: "Нажмите кнопку ниже, затем разрешите доступ в появившемся окне браузера",
    requestAccess: "Запросить доступ",
    continue: "Продолжить",
    selectDevices: "Выберите камеру и микрофон для звонка",
    joinWithoutCameraAndMic: "Продолжить без камеры и микрофона",
    joinWithoutCamera: "Продолжить без камеры",
    joinWithoutMic: "Продолжить без микрофона"
  },
  preferences: {
    title: "Настройки",
    enterYourName: "Введите ваше имя",
    enterYourNameLong: "Введите ваше имя, чтобы войти в конференцию",
    errorNameMustBeNotEmpty: "Имя не может быть пустым",
    errorNameMustNotTooLongBegin: "Имя не может быть более",
    errorNameMustNotTooLongEnd: "символов",
    errorAllowOnlyLettersAndSpaces: "Допустимы только буквы, цифры и пробелы внутри имени",
    cameraLabel: "Камера",
    microphoneLabel: "Микрофон",
    cameraLoading: "Загрузка камеры...",
    noCameras: "Камеры не найдены",
    noMicrophones: "Микрофоны не найдены",
    defaultCameraName: "Камера {index}",
    defaultMicrophoneName: "Микрофон {index}",
    micTestButton: "Тест микрофона",
    micTestStopButton: "Остановить запись",
    micTestStopPlaybackButton: "Остановить воспроизведение",
    micTestSpeak: "Говорите, идет запись.",
    micTestPlayback: "Воспроизведение",
    micTestNoAudio: "Микрофон не найден",
    micTestNotSupported: "Тест микрофона не поддерживается в этом браузере",
    micTestProgressHint: "0 — {seconds} с",
    speakerLabel: "Динамик",
    defaultSpeakerName: "Динамик {index}",
    speakerTestButton: "Тест динамика"
  },
  access: {
    error: 'Нет доступа к камере/микрофону',
    request: 'Запросить доступ',
    suggest: 'Если клавиша запроса доступа не действует, проверьте, нет ли запрета в настройках браузера. После изменения настроек, рекомендуется перезапустить браузер и заново зайти на сайт.'
  },
  settings: {
    videoTab: "Видео",
    audioTab: "Аудио",
    moreTab: "Ещё",
    debugInfo: "Отладочная информация",
    debugInfoDescription: "Показывать состояние соединений на видео",
    jitterBuffer: "Джиттер-буфер",
    jitterBufferDescription: "Увеличивает буфер для снижения потерь кадров при нестабильном соединении",
    virtualBackground: "Виртуальный фон",
    comingSoon: "скоро",
    recordingTab: "Запись",
    autoRecordOnPeerJoin: "Включать запись при появлении собеседника",
    autoRecordOnPeerJoinDescription: "Запись включится автоматически, когда в комнату войдёт кто-то ещё. Если запись отключить — сама она больше не включится; остановить запись можно в любой момент. При выходе собеседника запись не останавливается.",
    autoRecordFailed: "Не удалось включить запись автоматически",
  },
  videoElement: {
    cameraOff: "Камера выключена",
    micOff: "Микрофон выключен",
    ok: "ОК",
    cancel: "Отмена",
    screenShare: "Демонстрация экрана",
    stopSharing: "Остановить демонстрацию"
  },
  prejoin: {
    title: "Войти в конференцию",
    cancel: "Отмена",
    joinButton: "Войти в конференцию",
    updating: "Обновляем…",
    joinWithoutMedia: "Войти без камеры и микрофона",
    cameraOn: "Камера вкл",
    cameraOff: "Камера выкл",
    micOn: "Микрофон вкл",
    micOff: "Микрофон выкл",
    cameraDisabled: "Камера выключена",
    cameraUnavailable: "Камера недоступна",
    micDisabled: "Микрофон выключен",
    micUnavailable: "Микрофон недоступен",
    micLevel: "Уровень микрофона",
    enterNameHint: "Введите имя, чтобы войти",
    selectCamera: "Выбрать камеру",
    selectMic: "Выбрать микрофон",
    selectSpeaker: "Выбрать динамик",
    mediaAccessNeeded: "Для видеозвонка нужен доступ к камере и микрофону",
    enableCameraAndMic: "Включить камеру и микрофон",
    mediaAccessHint: "Чтобы вас видели и слышали, нужен доступ к камере и микрофону. Нажмите кнопку — браузер запросит разрешение",
  },
  permissions: {
    promptTitle: 'Нужен доступ к камере и микрофону',
    promptDescription: 'Для звонков разрешите доступ к камере и микрофону',
    openSettings: 'Открыть настройки',
    configure: 'Настроить',
    deniedTitle: 'Доступ к камере и микрофону запрещён',
    deniedDescription: 'Разрешите доступ в настройках браузера, чтобы участвовать в звонках',
    retryCheck: 'Я разрешил — проверить снова',
    cameraUnavailable: 'Камера недоступна',
    microphoneUnavailable: 'Микрофон недоступен',
    requestCameraAccess: 'Разрешить доступ к камере',
    requestMicAccess: 'Разрешить доступ к микрофону',
    instructionsChrome: 'Нажмите на значок 🔒 слева от адресной строки → Настройки сайта → Камера/Микрофон → Разрешить',
    instructionsFirefox: 'Нажмите на значок 🔒 слева от адресной строки → Разрешения → Камера/Микрофон',
    instructionsSafari: 'Safari → Настройки → Веб-сайты → Камера/Микрофон → Разрешить',
    instructionsDefault: 'Откройте настройки браузера и разрешите доступ к камере и микрофону для этого сайта'
  },
  errors: {
    mediaAccessDenied: 'Доступ к камере/микрофону запрещён. Проверьте разрешения браузера.',
    mediaNotFound: 'Камера или микрофон не найдены.',
    mediaOverconstrained: 'Выбранное устройство больше недоступно.',
    deviceBusy: 'Устройство используется другим приложением. Закройте другие приложения, использующие камеру или микрофон.',
    mediaAccessFailed: 'Не удалось получить доступ к камере/микрофону.',
    recordingFailed: 'Запись уже идёт в другой вкладке или окне браузера.',
    copyFailed: 'Не удалось скопировать ссылку. Скопируйте её вручную из адресной строки.',
    cameraSwitchFailed: 'Не удалось переключить камеру.',
  },
  recordings: {
    quotaUsed: '{usage} МБ из {quota} МБ',
    quotaWarning: 'Хранилище почти заполнено — удалите старые записи',
    lowSpace: 'Мало места в браузере — старые записи могут не сохраниться',
    export: 'Выгрузить',
    fragmentSize: '{size} МБ',
    delete: 'Удалить',
    recordingNow: 'идёт запись',
    title: 'Записи',
    close: 'Закрыть',
    empty: 'Записей пока нет',
    confirmDelete: 'Удалить этот файл?',
    localNotice: 'Хранится локально в этом браузере и может быть удалено браузером. Это не облако.',
    openHistory: 'История записей',
    closeHistory: 'Закрыть историю записей',
  },
  profileSection: {
    title: 'Профиль',
    namePlaceholder: 'Ваше имя',
    savedHint: 'Сохранено',
  },
  menu: {
    title: 'Настройки',
  },
  observation: {
    title: 'Режим наблюдения',
    description: 'Устройство будет держать комнату открытой. Экран останется тёмным, пока никого нет; камера включится, как только придёт участник.',
    arm: 'Начать наблюдение',
    waiting: 'Наблюдение · ожидание участников',
  },
  invite: {
    title: 'Вас пригласили в конференцию',
    enter: 'Перейти',
    cancel: 'Отмена',
  },
}
